import React, { useEffect, useState } from "react";
import Loading from "../../../loading/loading.index";
import { Button, Collapse, Input } from "antd";
import { get, post, responseValidator, SERVER } from "../../../api";
import { toast } from "react-toastify";
import "./index.scss";
import UserMessage from "./message";
import { Typography } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import DragDrop from "../../components/dataEntry/Upload/DragDrop";

export default function TicketDetail() {
    const [isLoading, setIsLoading] = useState(true);
    const [detail, setDetail] = useState(true);
    const [time, setTime] = useState(undefined);
    const [state, setState] = useState(undefined);
    const [messages, setMessages] = useState([]);
    const [attachment, setAttachment] = useState(undefined);
    const [fileID, setFileID] = useState(undefined);
    const [text, setText] = useState(undefined);
    const [submitLoading, setSubmitLoading] = useState(false);

    let id = window.location.href.split("/")[6];
    const { Text } = Typography;
    const { Panel } = Collapse;

    function finishUploadHandler(e) {
        console.log(e.response);
        setAttachment(e.response.data.file);
        setFileID(e.response.data.id);
    }

    function submitHandler() {
        setSubmitLoading(true);
        post("/Ticket/Message", {
            ticket: id,
            text: text,
            attachment: fileID
        }).then(res => {
            setSubmitLoading(false);
            if (responseValidator(res.status)) {
                toast.success(res.data.message);
                setTimeout(
                    () =>
                        window.location.replace(
                            `/userpanel/ticket/detail/${id}`
                        ),
                    2000
                );
            } else toast.error(res.data.message);
        });
    }

    useEffect(() => {
        get(`/Ticket/${id}`).then(response => {
            setIsLoading(false);
            if (responseValidator(response.status)) {
                setDetail(response.data.data);
                setTime(response.data.data.dateTime);
                setState(response.data.data.state.title);
                setMessages(response.data.data.ticketMessages);
                console.log(response.data.data);
            } else {
                toast.error(response.data.message);
                if (response.status === 403)
                    setTimeout(() => {
                        window.location.replace("/authorization/");
                    }, 3000);
            }
        });
    }, []);

    return (
        <div className="gx-main-content row ticket-detail">
            {isLoading && <Loading />}
            <div className="row main-card">
                <div className="col-12 title-card my-header">
                    <h3 className="title-text">جزییات تیکت</h3>
                    <span />
                    <Button
                        onClick={() =>
                            window.location.replace("/userpanel/ticket")
                        }
                        type={"link"}
                    >
                        بازگشت
                    </Button>
                </div>
            </div>

            {detail && (
                <div className="row ant-card gx-card-widget detail-header">
                    <div className="header">
                        <div className="header-items">
                            <span className="state-title">
                                زمان ایجاد تیکت :{"  "}
                            </span>
                            <p>
                                {time &&
                                    time.split(":")[0].slice(11, 13) +
                                    ":" +
                                    time.split(":")[1] +
                                    " - " +
                                    new Date(time).toLocaleDateString(
                                        "fa-IR"
                                    )}
                            </p>
                        </div>
                        <div className="header-items">
                            <span className="state-title">
                                اخرین وضعیت تیکت :{"  "}
                            </span>
                            <Text
                                className={
                                    state && state === "Waiting"
                                        ? "text wait"
                                        : state === "Answered"
                                            ? "text done"
                                            : "text"
                                }
                            >
                                {state && state === "Waiting"
                                    ? "در انتظار"
                                    : state === "Closed"
                                        ? "بسته شده"
                                        : "پاسخ داده شده"}
                            </Text>
                        </div>
                    </div>
                    <Collapse
                        bordered={true}
                        defaultActiveKey={["2"]}
                        expandIcon={({ isActive }) => (
                            <CaretRightOutlined
                                style={{ color: "white" }}
                                rotate={isActive ? 90 : 0}
                            />
                        )}
                        className="site-collapse-custom-collapse reply-button"
                    >
                        <Panel
                            header={
                                <span style={{ color: "white" }}>پاسخ</span>
                            }
                            key="1"
                            className="site-collapse-custom-panel custom-panel"
                        >
                            <div className="main-div">
                                <label>متن پاسخ</label>
                                <Input.TextArea
                                    onChange={e => setText(e.target.value)}
                                    className="text-area"
                                    name="متن پاسخ"
                                    placeholder="متن پاسخ خود را وارد کنید."
                                />
                                <label>فایل</label>
                                {attachment ? (
                                    <div className="nationalCard"></div>
                                ) : (
                                    <DragDrop
                                        accept="image/*, .zip, .rar"
                                        finish={e => finishUploadHandler(e)}
                                        name="file"
                                        multiple={false}
                                        url={SERVER + "/Media/Upload"}
                                    />
                                )}
                                <Button
                                    className="my-real-btn"
                                    disabled={!text}
                                    onClick={submitHandler}
                                    type={"primary"}
                                    loading={submitLoading}
                                >
                                    ثبت
                                </Button>
                            </div>
                        </Panel>
                    </Collapse>
                    {messages &&
                        messages.map(item => {
                            return (
                                <UserMessage
                                    className={
                                        item.sender === "Admin"
                                            ? "admin-message-main"
                                            : "user-message-main"
                                    }
                                    fileByteContent={
                                        item.attachment &&
                                        item.attachment.fileByteContent
                                    }
                                    contentType={
                                        item.attachment &&
                                        item.attachment.contentType
                                    }
                                    fileName={
                                        item.attachment &&
                                        item.attachment.fileName
                                    }
                                    attachment={item.attachment}
                                    text={item.text}
                                    sender={item.sender}
                                    dateTime={
                                        item.dateTime
                                            .split(":")[0]
                                            .slice(11, 13) +
                                        ":" +
                                        item.dateTime.split(":")[1] +
                                        " - " +
                                        new Date(
                                            item.dateTime
                                        ).toLocaleDateString("fa-IR")
                                    }
                                />
                            );
                        })}
                </div>
            )}
        </div>
    );
}
